// One reading of a rejected save, shared by every form that persists an
// artifact. The service layer wraps gRPC failures as
// "Failed to create artifact: <server message>", so strip that wrapper and
// show what the server actually said (a permission refusal, a validation
// message). Anything without a usable message gets one short line instead.
const SERVICE_WRAPPER = /^Failed to [a-z]+ [a-z ]+?:\s*/i;
export const GENERIC_SAVE_ERROR = 'Could not save. Please try again.';
export function messageFromSaveError(err, generic = GENERIC_SAVE_ERROR) {
    const raw = err instanceof Error ? err.message :
        typeof err === 'string' ? err :
            '';
    const message = raw.replace(SERVICE_WRAPPER, '').trim();
    if (message.length === 0 || message === 'undefined')
        return generic;
    return message;
}
